import { Validators } from '@angular/forms';
import { GetCountriesData } from '@shared';
import { codeUKTZEDUSAPattern } from '../components/parcel-places/ii-code-uktzed/ii-code-uktzed.constants';
import { CountryRecipientPayerConfig, DefaultCountryPhoneConfig } from '../international-invoice.constants';

// USA
export const US: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  ...CountryRecipientPayerConfig,
  State: {
    getMethodName: 'getUSStates',
    config: {
      ariaLabel: 'Штат',
      placeholder: 'Штат',
      arrow: true,
    },
    errorSnackMessages: {
      empty: 'Не заповнений штат отримувача',
      fromList: 'Оберіть штат зі списку',
    }
  },
  CodeUKTZED: {
    validators: [
      Validators.pattern(codeUKTZEDUSAPattern),
      Validators.required,
    ],
    resetFieldsWhenSwitchedToThisCountry: true,
    maxLength: 10,
  },
};
